import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { TableData } from './TableData';
import { TableRow } from './TableRow';

export const TableLoading = ({
  rowCount = 10,
  columnCount = 5,
}: {
  rowCount?: number;
  columnCount?: number;
}) => (
  <>
    {Array(rowCount)
      .fill(0)
      .map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array(columnCount)
            .fill(0)
            .map((_, columnIndex) => (
              <TableData key={columnIndex}>
                <Skeleton height={16} />
              </TableData>
            ))}
        </TableRow>
      ))}
  </>
);
